import {
  Flex,
  LinearProgress,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { t } from 'i18next';

interface MitigationProgressProps {
  mitigationProgress: number;
  mitigationDone: number;
  mitigationTotal: number;
}

export const MitigationProgress = ({
  mitigationProgress,
  mitigationDone,
  mitigationTotal,
}: MitigationProgressProps) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  return (
    <Flex columnGap="3x">
      <LinearProgress
        variant="determinate"
        value={mitigationProgress}
        width={160}
        height={10}
        color="blue:50"
        my="auto"
      />
      <Text size="md">
        {mitigationDone}/
        <Text display="inline-block" color={colorStyle.color.secondary}>
          {mitigationTotal}
        </Text>{' '}
        ({mitigationProgress}%) {t('operations.euq.mitigation.completed')}
      </Text>
    </Flex>
  );
};
